<template>
    <header id="header" class="fixed-top">
      <div class="container-fluid d-flex">
        <div class="logo mr-auto">
          <a href="#"><img src="./../assets/img/logo.png" alt="" class="img-fluid"></a>
        </div>
        <nav class="nav-menu d-lg-block">
        
          <ul>
            <li>
                <router-link to="/en">
                    <img src="./../assets/img/en.svg" height="20px" @click="changeLang('en-US')" :alt="__('english')">
                </router-link>
            </li>
            <li>
                <router-link to="/sv">
                    <img src="./../assets/img/sv.svg" height="20px" @click="changeLang('sv-SE')" :alt="__('swedish')">
                </router-link>
            </li>
            <li>
                <router-link to="/no">
                    <img src="./../assets/img/nb.svg" height="20px" @click="changeLang('no-NO')" :alt="__('norwegian')">
                </router-link>
            </li>
            <li class="login d-none d-lg-block"><a :href="'https://app.signr.se/?lang=' + lang.substr(0,2)">{{__('login')}}</a></li>
          </ul>
        </nav>
      </div>
    </header>
</template>
<script>
export default {
    props: ['lang'],
    methods :{
        changeLang(lang){
            this.$emit('changeLang', lang)
        }
        
    }
}
</script>